import { mapGetters } from "vuex";

export default {
  data() {
    return {
      subscription: null,
    };
  },
  computed: {
    ...mapGetters("stompClient", {
      isStompConnected: "getStompConnect",
    }),
  },
  watch: {
    isStompConnected: {
      handler(newValue) {
        if (newValue) {
          this.subscribeToTopic();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  },
};
